import { getCurrentUser } from "aws-amplify/auth";

/**
 * Add Staff and Add Doctor always create a NEW account, and email is unique
 * platform-wide, so entering your own email can only end in a 409. An Admin who
 * practises becomes a doctor on their existing account by uploading their NMC
 * registration (POST /me/practitioner-enrollment) instead.
 */
export const OWN_EMAIL_MESSAGE =
  "This is your own email. To practise as a doctor, upload your NMC registration in " +
  "Settings > Compliance & Verification.";

/** True when `email` is the signed-in user's login email. False if it cannot be resolved. */
export async function isOwnEmail(email: string): Promise<boolean> {
  try {
    const { signInDetails } = await getCurrentUser();
    const own = (signInDetails?.loginId ?? "").trim().toLowerCase();
    return own !== "" && own === email.trim().toLowerCase();
  } catch {
    return false;
  }
}
